import axios from "axios";
import { z } from "zod";
import { toast } from "../../components/ui/use-toast";
import { CircleCheckBig } from "lucide-react";
const baseUrl = process.env.REACT_APP_SERVER_URL;

export const getAllTeam = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/team`);
    return { teams: response.data.teams };
  } catch (error) {
    console.error(error);
  }
};

export const handleCreateTeam = async (formData: any, navigate: Function) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const newsFormData = new FormData();

    if (formData.image && Array.isArray(formData.image)) {
      formData.image.forEach((image: any, index: any) => {
        newsFormData.append(`image`, image.file);
      });
    }

    const response = await axios.post(
      `${baseUrl}/api/team/`,
      newsFormData,
      config
    );

    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">{response.data.msg}</span>
        </div>
      ),
    });
    navigate("/admin-dashboard/organigramme-equipe");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const handleUpdateTeam = async (
  id: number,
  formData: any,
  navigate: Function
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const formDataToSend = new FormData();
    if (formData.image) {
      if (formData.image && Array.isArray(formData.image)) {
        formData.image.forEach((image: any, index: any) => {
          formDataToSend.append(`image`, image.file);
        });
      }
    }

    const response = await axios.patch(
      `${baseUrl}/api/team/${id}`,
      formDataToSend,
      config
    );
    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">{response.data.msg}</span>
        </div>
      ),
    });

    navigate("/admin-dashboard/organigramme-equipe");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const deleteTeam = async (id: number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.delete(`${baseUrl}/api/team/${id}`, config);
    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">
            {response.data.message}
          </span>
        </div>
      ),
    });
  } catch (error) {
    console.error(error);
  }
};

export const getTeamById = async (id: number) => {
  try {
    const response = await axios.get(`${baseUrl}/api/team/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
